import React, {Fragment, useContext} from "react";
import NsTabellaMobile from "./NsTabellaMobile";
import NsTabellaDesktop from "./NsTabellaDesktop";
import {MobileContext} from "../../context/MobileContext";

function NsDataTable({
                         data,
                         columns,
                         funzioneFiltro,
                         componenteFiltro,
                         additionalClasses,
                         conditionalRowStyles,
                         onRowClicked,
                         onRowDbClick,
                         pagina,
                         totalePagine,
                         handlerCambioPagina,
                         addFiltri = false,
                         addDetail = false,
                         getDettaglio,
                         orderBy,
                         orderByColonna = '',
                         orderByDirezione = '',
                         recordPerPagina = 30,
                         totRighe
                     }) {

    const {isMobile} = useContext(MobileContext);

    return (
        <Fragment>
            {
                isMobile ?
                    <NsTabellaMobile
                        columns={columns}
                        conditionalRowStyles={conditionalRowStyles}
                        additionalClasses={additionalClasses}
                        onRowClicked={onRowClicked}
                        onRowDbClick={onRowDbClick}
                        data={data}
                        addDetail={addDetail}
                        getDettaglio={getDettaglio}
                    />
                    : <NsTabellaDesktop
                        columns={columns}
                        conditionalRowStyles={conditionalRowStyles}
                        additionalClasses={additionalClasses}
                        onRowClicked={onRowClicked}
                        onRowDbClick={onRowDbClick}
                        data={data}
                        addDetail={addDetail}
                        addFiltri={addFiltri}
                        funzioneFiltro={funzioneFiltro}
                        componenteFiltro={componenteFiltro}
                        getDettaglio={getDettaglio}
                        orderBy={orderBy}
                        orderByColonna={orderByColonna}
                        orderByDirezione={orderByDirezione}
                        recordPerPagina={recordPerPagina}
                        totRighe={totRighe}
                        paginaCorrente={pagina}
                        totalePagine={totalePagine}
                        handlerCambioPagina={handlerCambioPagina}
                    />
            }
        </Fragment>
    );

}

export default NsDataTable;